<template>
  <button
    type="button"
    class="hover:text-active-primary flex h-8 items-center justify-center gap-1 rounded-xl px-3 text-sm font-medium leading-none"
    :class="[
      active && 'bg-active-secondary text-active-primary cursor-default',
      !active && 'bg-gray-10 text-gray-60 hover:bg-active-secondary-hover',
    ]"
    @click="$emit('click')"
  >
    <slot />
    <slot name="icon" />
    <span
      v-if="typeof count === 'number'"
      class="flex h-4 min-w-4 items-center justify-center rounded-md px-1 text-xs leading-none"
      :class="[active && 'bg-active-secondary mix-blend-multiply', !active && 'bg-gray-20', error && 'text-red-70']"
    >
      {{ count }}
    </span>
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    active?: boolean
    count?: number | null
    error?: boolean
  }>(),
  {
    count: null,
  },
)

defineEmits<{
  (e: 'click'): void
}>()
</script>
